'use client';

import { PropsWithChildren } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { ProtectedLayer } from '@/providers';
import { Shell } from '../shell';
import { Private } from './Private';
import useIsRegistryRoute from '@/hooks/useIsRegistryRoute';

export default function PrivateGate({ children }: PropsWithChildren) {
  const isAuthenticated = useIsAuthenticated();
  const isRegistryRoute = useIsRegistryRoute();

  return isAuthenticated || isRegistryRoute ? (
    <Private>
      <ProtectedLayer>
        <Shell>{children}</Shell>
      </ProtectedLayer>
    </Private>
  ) : (
    <Shell>{children}</Shell>
  );
}
